const EMAIL_SEPARATOR = '@'

export const isEmailLike = (value: string): boolean => value.includes(EMAIL_SEPARATOR)
